import { MaxWidth } from "shared/components/MaxWidth";
import { RichText } from "shared/components/RichText";
import { SMALL, TYPE_RICHTEXT_SIMPLE } from "shared/utils/constants";
import BlockContent from "@sanity/block-content-to-react";
import styles from "./Table.module.css";
import { onlyLinkSerializers } from "shared/components/Content";

export const TableContainer = ({ title, fields, size = SMALL }) => (
  <div className="TableContainer">
    <MaxWidth size={size}>
      <Table title={title} fields={fields} />
    </MaxWidth>
  </div>
);

export const Table = ({ title, fields }) => (
  <>
    {title && (
      <div className={styles.sectionTitle}>
        <RichText>
          <h2>{title}</h2>
        </RichText>
      </div>
    )}

    {fields && (
      <div className={styles.wrapper}>
        <table>
          <tbody>
            {fields.map(({ columns }, i) => (
              <tr key={i}>
                {columns.map(({ value }, ii) => (
                  <td key={ii}>
                    <RichText type={TYPE_RICHTEXT_SIMPLE}>
                      {typeof value === "string" ? (
                        <p>{value}</p>
                      ) : (
                        <BlockContent
                          blocks={value}
                          serializers={onlyLinkSerializers}
                        />
                      )}
                    </RichText>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </>
);
